import { config } from "@app-contexts/sdk/services/config";
import { Widget, WidgetQueryParams } from "@app-contexts/sdk/services/Widget";
import { checkoutWidget } from "./checkout";

/**
 * Shows a product purchase widget for the specified event
 * @param id id of product
 * @param params values to add to URL params (e.g. 'theme-primary', 'theme-secondary', etc.)
 * @param containerId id of the container to embed the widget in
 */
export async function productPurchaseWidget(
  id: string,
  params: WidgetQueryParams,
  containerId?: string
) {
  const widget = new Widget({
    src: await config.productPurchaseWidgetUrl(id),
    containerId,
    queryParams: params,
  });

  widget.show().on("showpass.product-purchase.checkout", () => {
    widget.close({ removeBodyClass: false });
    checkoutWidget(params);
  });

  return widget;
}
